import { DocumentsList } from '@/components/documents/DocumentsList';

export const DocumentsPage = () => {
  return <DocumentsList />;
};
